import $ from 'jquery';
import Toastify from 'toastify-js';

// Latin letters, spaces, apostrophes, dots and hyphens.
const NAME_DISALLOWED = /[^A-Za-zÀ-ÖØ-öø-ÿĀ-ſ '.-]/g;

/**
 * The newsletter form (#web2lead, partial/_webtolead.antlers.html): client
 * side validation, the POST to /api/postSend (Salesforce Web-to-Lead, see
 * Web2LeadController) and the iubenda consent record.
 */
export function initNewsletterForm() {
    const element = document.getElementById('web2lead');
    if (element === null) return;

    // BIRTHDATE must be at least 14 years ago. Computed in JS (not Antlers/server)
    // so a cached page can't serve a stale max. Native validation blocks submit
    // before the submit event fires (where preventDefault lives).
    const birthdateInput = document.getElementById('birthdate');
    if (birthdateInput) {
        const now = new Date();
        const maxDate = new Date(now.getFullYear() - 14, now.getMonth(), now.getDate());
        const pad = n => String(n).padStart(2, '0');
        birthdateInput.max = maxDate.getFullYear() + '-' + pad(maxDate.getMonth() + 1) + '-' + pad(maxDate.getDate());
    }

    // FIRST/LAST NAME: latin-only. The pattern attribute only validates on submit
    // and does not prevent typing, so strip disallowed chars live (Cyrillic, etc.)
    // while preserving the caret position.
    $('#web2lead input[name="first_name"], #web2lead input[name="last_name"]').on('input', function () {
        const clean = this.value.replace(NAME_DISALLOWED, '');
        if (clean !== this.value) {
            const start = this.selectionStart;
            const removed = this.value.length - clean.length;
            this.value = clean;
            const pos = Math.max(0, start - removed);
            try { this.setSelectionRange(pos, pos); } catch (e) { /* unsupported input type */ }
        }
    });

    element.addEventListener('submit', event => {
        event.preventDefault();

        var formData = {
            GuestFirstname: $('input[name="first_name"]').val(),
            GuestName: $('input[name="last_name"]').val(),
            Email: $('input[name="email"]').val(),
            Birthdate: $('input[name="birthdate"]').val(),
            Nationality: $('#web2lead [name="country"]').val(),
            '00N0900000G0P0K': $('input[name="00N0900000G0P0K"]').val(),
            lead_source: $('input[name="lead_source"]').val(),
            URL: $('input[name="url"]').val(),
            marketing: $('input[name="marketing"]').is(':checked'),
            profiling: $('input[name="profiling"]').is(':checked'),
            channel: $('input[name="channel"]').val(),
            brand: $('input[name="brand"]').val(),
        };

        $.ajax({
            type: 'POST',
            data: JSON.stringify(formData),
            url: '/api/postSend',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // Cloudflare Turnstile token, checked by the VerifyTurnstile middleware.
                // Empty without the widget (no TURNSTILE_SITE_KEY, local/CI).
                'X-Turnstile': $('#web2lead input[name="cf-turnstile-response"]').val() || '',
            },
        }).done(function () {
            if (window._iub) {
                window._iub.cons_instructions.push(['submit', {
                    writeOnLocalStorage: false,
                    form: {
                        selector: document.getElementById('web2lead'),
                        map: {
                            subject: {
                                first_name: 'first_name',
                                last_name: 'last_name',
                                email: 'email',
                            },
                            preferences: {
                                generic: 'generic',
                                newsletter: 'newsletter',
                            },
                        },
                    },
                    consent: {
                        legal_notices: [
                            { identifier: 'privacy_policy' },
                            { identifier: 'cookie_policy' },
                            { identifier: 'terms' },
                        ],
                    },
                }, {
                    success: function () {
                        markSubmitted();
                    },
                    error: function (response) {
                        console.warn('[newsletter-form] iubenda consent not recorded:', response);
                    },
                }]);
            } else {
                // No iubenda on this environment (it is production-only).
                markSubmitted();
            }
        }).fail(function (jqXHR, textStatus) {
            console.error('[newsletter-form] POST /api/postSend failed:', textStatus, jqXHR);
            Toastify({
                text: element.dataset.errorMessage,
                className: 'info',
                style: { background: 'red', color: 'white' },
            }).showToast();
            // A Turnstile token is single-use: get a new one for the next attempt, with the submit
            // disabled until the widget calls web2leadTurnstileOk again (partial/_webtolead.antlers.html).
            if (window.turnstile) {
                window.web2leadTurnstileKo();
                window.turnstile.reset('#web2lead .cf-turnstile');
            }
        });
    });
}

function markSubmitted() {
    $('#web2lead button[type="submit"]').removeClass('active').addClass('finished').attr('disabled', 'disabled');
    $('#web2lead input[type="text"], #web2lead input[type="email"], #web2lead input[type="date"]').val('');
    resetWeb2leadExtras();
}

// Reset the extra #web2lead fields the generic text/email/date clear can't cover:
// the hidden country value, the nationality combobox custom validity, and the
// VISIBLE consent checkboxes. The hidden generic/newsletter checkboxes stay checked
// (they are always-on and read by Iubenda).
function resetWeb2leadExtras() {
    const form = document.getElementById('web2lead');
    if (!form) return;
    const country = form.querySelector('[name="country"]');
    if (country) country.value = '';
    const nationality = document.getElementById('nationality');
    if (nationality && nationality.setCustomValidity) nationality.setCustomValidity('');
    $('#web2lead input[name="marketing"], #web2lead input[name="profiling"]').prop('checked', false);
}
